export default __webpack_public_path__ + "static/media/help28b.ea61f6bd.png";